bravo.scripts = (function () {
	'use strict';

	const initialize = () => {
		bravo.utilities.getScrollbarWidth();
		bravo.welcome.init();
		bravo.warning.init();
		bravo.intro.init();
		bravo.timeline.init();
		bravo.components.init();
		bravo.menu.init();
		bravo.enews.init();
		bravo.search.init();
	};

	const unInitialize = () => {
		bravo.intro.unInit();
		// bravo.menu.unInit();
		// bravo.search.unInit();
		bravo.timeline.unInit();
	};

	const swupReInitialize = () => {
		bravo.utilities.getScrollbarWidth();
		bravo.welcome.init();
		bravo.warning.init();
		bravo.intro.init();
		bravo.timeline.init();
		bravo.components.init();
	};

	return {
		init: initialize,
		unInit: unInitialize,
		swupReInit: swupReInitialize
	};
})();

bravo.swup.init();
bravo.scripts.init();